import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  HStack,
} from '@chakra-ui/react';
import { CiSettings } from "react-icons/ci";

const UserModal = ({ myself = false, children }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <>
      <Button
        onClick={handleOpenModal}
        backgroundColor={myself ? 'transparent' : '#4945FF'}
        _hover={{
          backgroundColor: myself ? 'transparent' : '#7B79FF',
          color: myself ? '#7B79FF' : 'white',
        }}
        color={myself ? '#4945FF' : 'white'}
      >
        <CiSettings size={myself ? 35 : 25} />
      </Button>

      <Modal isOpen={isOpenModal} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent
          fontFamily={"'Jura', sans-serif"}
          backgroundColor={'#212134'}
          color={'white'}
        >
          <ModalHeader>Пользователь</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>
          <ModalFooter>
            <Button onClick={handleCloseModal}>Закрыть</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UserModal;
